'use client';

import classNames from 'classnames';
import { useIntl } from 'react-intl';
import StatusBadge from '@alltrails/denali/components/StatusBadge';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import NationalParkFilled from '@alltrails/denali/icons/NationalParkFilled';
import { useExperiments } from '@alltrails/experiments';
import styles from './ManagedBadge.module.scss';

type ManagedBadgeProps = {
  isManaged?: boolean;
};

export default function ManagedBadge({ isManaged }: ManagedBadgeProps) {
  const intl = useIntl();
  const isMobile = useIsMobileSizedScreen();
  const isPLPBadgingEnabled = useExperiments()['web-tmt-rm-plp-badging']?.value === 'on';

  if (!isPLPBadgingEnabled || !isManaged) {
    return null;
  }

  return (
    <div className={styles.inline}>
      <div className={classNames(styles.dividerDot, { [styles.mobile]: isMobile })}>·</div>
      {!isMobile ? (
        <StatusBadge
          icon={{ Component: NationalParkFilled }}
          variant="inverse"
          text={intl.formatMessage({ defaultMessage: 'Managed' })}
          size="sm"
          treatment="default"
        />
      ) : (
        <NationalParkFilled className={styles.mobile} size="xs" />
      )}
    </div>
  );
}
